<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card v-on:keyup.enter="buildNewSearch">
        <v-layout align-center justify-center row>
            <v-flex xs2>
                <v-text-field class="ma-2" browser-autocomplete="off" v-model="dataTable.searchFields.name" label="Imię"
                    aria-label="name" for="users-view-name" id="users-view-name">
                </v-text-field>
            </v-flex>
            <v-flex xs2>
                <v-text-field class="ma-2" browser-autocomplete="off" v-model="dataTable.searchFields.surname"
                    label="Nazwisko" aria-label="surname" for="users-view-surname" id="users-view-surname">
                </v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-layout align-center justify-center row>
                    <v-btn @click="buildNewSearch" color="primary" dark class="mb-2">Szukaj</v-btn>
                    <v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-data-table :headers="dataTable.tableHeaders" :rows-per-page-items="[10, 20, 25]" :loading="dataTable.loading"
            :items="dataTable.itemList" :total-items="dataTable.itemCount" :pagination.sync="dataTable.pagination"
            class="elevation-1">
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.surname }}</td>
                <td class="text-xs-left">
                    <span class="notAccepted-user" v-if="!props.item.accepted"
                        style="color:darkred"><b>Niezaakceptowany</b><br></span>
                    <span class="active-user" v-else-if="props.item.active" style="color:#0075e2">Aktywny</span>
                    <span class="inactive-user" v-else style="color:red">Nieaktywny</span>
                </td>
                <td class="text-xs-left">


                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click="showProfile(props.item)">
                                <v-icon v-on="on">
                                    person
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Profil</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-if="props.item.active && canBeAllowedToView(props.item)"
                                @click="showAllowances(props.item)">
                                <v-icon v-on="on" color="primary">
                                    screen_share
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Udostępnienia</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                v-if="['Administrator główny', 'Administrator lokalny', 'Pracownik departamentu'].includes(props.item.role)"
                                @click="showSupervisedProjects(props.item.id)">
                                <v-icon v-on="on" color="primary">
                                    folder_shared
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Projekty opiekuna</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { Api } from "@/api";
import { role } from "@/utils/Role";
import { Filters } from "@/utils/Filters";

export default {
    name: "UsersView",

    mixins: [Filters],

    watch: {
       
        "dataTable.pagination": {
            handler(pagination) {
                this.getItemList();
                this.paginationRef = pagination;
            },
            deep: true
        },
    },

    created() {
        this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
        this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
        this.buildNewSearch();
    },

    computed: {
        pages() {
            // paginacja nie została zainicjalizowana
            if (this.dataTable.pagination.rowsPerPage === undefined) {
                return 0;
            }
            return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
        },

        isEdited() {
            return this.editedIndex !== -1;
        }
    },

    data() {
        return {
            dataTable: {
                searchFields: {
                    email: "",
                    name: "",
                    surname: "",
                    role: ""
                },
                tableHeaders: [
                    { text: "Imię", sortable: true, value: "name" },
                    { text: "Nazwisko", sortable: true, value: "surname" },
                    { text: "Status", sortable: false, value: "status" },
                    { text: "Akcje", sortable: false, value: "actions" },
                ],
                loading: false,
                itemList: [],
                itemCount: 0,
                pagination: {
                    rowsPerPage: 25
                },
                search: "",
            },


            administratorRoleList: ["Administrator główny", "Administrator lokalny", "Pracownik departamentu",
                "Pracownik placówki", "Ekspert", "Przeglądający"],

            localAdministratorRoleList: ["Pracownik departamentu",
                "Pracownik placówki", "Ekspert", "Przeglądający"],

            systemRoles: [
                "Administrator główny",
                "Administrator lokalny",
                "Pracownik departamentu",
                "Pracownik placówki",
                "Ekspert",
                "Oferent - konto główne",
                "Oferent - subkonto",
                "Wolontariusz",
                "Przeglądający"
            ],

            agencies: [],

            departments: [],

            clicked: false,
        };
    },

    methods: {
        canBeAllowedToView(item) {
            return item.role !== 'Oferent - konto główne' &&
                item.role !== 'Oferent - subkonto' &&
                item.role !== 'Wolontariusz' &&
                item.role !== 'Administrator lokalny' &&
                item.role !== 'Administrator główny' &&
                (this.roles.isAdministrator() || this.roles.isLocalAdministrator());
        },

        buildNewSearch() {
            this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
            this.getItemList();
        },

        getItemList() {
            if (this.dataTable.pagination.page) {
                let sort = this.buildSort();
                Api.get(this,
                    "/user/list?search=" + this.dataTable.search
                    + "&page=".concat(this.dataTable.pagination.page)
                    + "&result=".concat(this.dataTable.pagination.rowsPerPage)
                    + "&sort=".concat(sort), response => {
                        this.dataTable.itemList = response.itemList;
                        this.dataTable.itemCount = response.itemCount;
                    });
            }
        },


        buildSort() {
            let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
            let columnName = this.dataTable.pagination.sortBy;
            if (order && columnName) {
                return columnName.concat(" ").concat(order);
            } else {
                return "";
            }
        },

        resetSearch() {
            this.clearFields();
            this.buildNewSearch();
        },

        clearFields() {
            this.dataTable.searchFields.name = "";
            this.dataTable.searchFields.surname = "";
            this.dataTable.searchFields.email = "";
            this.dataTable.searchFields.role = "";
        },

        availableRoleList() {
            if (role.isAdministrator()) {
                return this.administratorRoleList;
            }

            if (role.isLocalAdministrator()) {
                return this.localAdministratorRoleList;
            }
        },

        buildSearch(searchFields) {
            let search = "";
            if (searchFields.email) {
                search = search.concat("email::" + searchFields.email + "$$");
            }
            if (searchFields.name) {
                search = search.concat("name::" + searchFields.name + "$$");
            }
            if (searchFields.surname) {
                search = search.concat("surname::" + searchFields.surname + "$$");
            }
            if (searchFields.role) {
                search = search.concat("role::" + searchFields.role + "$$");
            }
            search = search.concat("departmentId::" + this.$route.params.departmentId + "$$");

            return search;
        },


        showProfile(item) {
            if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
                this.$router.push("/app/profile/" + item.id);
            } else {
                this.$router.openInNewTab({ name: "profileView", params: { userId: item.id } });
            }
        },

        showAllowances(item) {
            this.$router.push("/app/allowances/" + item.id);
        },

        showSupervisedProjects(userId) {
            this.$router.push("/app/supervised-projects/".concat(userId));
        },
    
    },
};
</script>

<style scoped>
.theme--dark .notAccepted-user {
    color: #fff !important;
}

.theme--dark .inactive-user {
    color: #D5233F !important;
}

.theme--dark .active-user {
    color: #fff !important;
}

.theme--dark.v-icon {
    color: #fff !important;
}


.theme--dark .red--text {
    color: #f4ec0d !important;
}

.theme--dark .green--text {
    color: #fff !important;
}
</style>
